/*
 * sr-quick-buy-buy-now.js (v2, this session)
 * ---------------------------------------------------------------------
 * Fix: "ella product ku match aaganum" (Buy Now / Magic Checkout must work
 * for every product, not just sarees) - follow-up to the PDP fix already
 * applied in snippets/native-customization.liquid (v16).
 *
 * TWO call sites render a "Buy it now" action for non-saree products using
 * ONLY Shopify's native dynamic checkout button ({{ form | payment_button }}):
 *
 *   1. snippets/product-quick-buy.liquid (v2) - the Quick Buy drawer content,
 *      opened from a collection/search grid's "Quick Add" trigger.
 *   2. snippets/product-card.liquid (v2) - the "Buy it now" button rendered
 *      directly on every product card (collection grids, homepage
 *      collections, recommendation carousels, "You may also like", etc.) -
 *      by far the most-seen instance of this button on the site.
 *
 * Per the same root cause documented in native-customization.liquid
 * (v10/v11): Razorpay's script only reliably intercepts a click on the CART
 * PAGE's own native checkout button - not a card/drawer/PDP dynamic-
 * checkout click - so both of the above could fall through to plain
 * Shopify checkout instead of Magic Checkout for non-saree products
 * (Kurti, Accessories, etc.), exactly like the original PDP bug.
 *
 * Fix: both templates now suppress their native dynamic checkout button and
 * instead render a custom button:
 *   - product-quick-buy.liquid  -> [data-quick-buy-custom-buy-now]
 *   - product-card.liquid       -> [data-product-card-custom-buy-now]
 *
 * IMPORTANT (Quick Buy only): that markup lives inside a
 * <template id="quick-buy-content"> that the theme's own quick-buy-drawer
 * machinery clones into the live DOM - an inline <script> in that template
 * would never execute (script tags do not auto-run when cloned). Product
 * cards render directly in the live DOM, so no such constraint applies
 * there, but a single shared, document-level delegated click listener
 * (matching sr-add-to-bag.js's own [data-atb-trigger] pattern) still keeps
 * both cases correct and avoids per-instance binding entirely.
 *
 * Behavior: adds the currently selected variant to the cart via
 * /cart/add.js, then redirects to /cart?buy_now=1 - the same handoff
 * assets/customization-sync.js already listens for on the cart page to
 * programmatically click the real checkout button and open Magic Checkout.
 */
(function () {
  if (window.__srQuickBuyBuyNowInstalled) return;
  window.__srQuickBuyBuyNowInstalled = true;

  var busy = false;

  function fail(btn, errorEl, message) {
    busy = false;
    btn.disabled = false;
    btn.textContent = btn.dataset.originalLabel || 'Buy it now';
    if (errorEl) {
      errorEl.hidden = false;
      errorEl.textContent = message;
    }
  }

  async function onCustomBuyNow(btn, form) {
    if (busy) return;

    var errorEl = form
      ? form.querySelector('[data-quick-buy-buy-now-error], [data-product-card-buy-now-error]')
      : null;

    var variantInput = form ? form.querySelector('input[name="id"]') : null;
    var variantId = variantInput ? parseInt(variantInput.value, 10) : null;

    if (!variantId) {
      fail(btn, errorEl, 'Please select a product option before continuing.');
      return;
    }

    // Stay in sync with a native Add to Cart submit button's own disabled
    // state, when one exists in the same form (toggled client-side by
    // variant-picker.liquid when the shopper picks an out-of-stock
    // combination), so we never try to buy an unavailable variant.
    var atcButton = form ? form.querySelector('button[type="submit"]') : null;
    if (atcButton && atcButton.disabled) {
      fail(btn, errorEl, 'This option is currently unavailable.');
      return;
    }

    busy = true;
    btn.dataset.originalLabel = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Processing…';
    if (errorEl) errorEl.hidden = true;

    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });
      if (!res.ok) throw new Error('Failed to add the product to your cart');
      window.location.href = '/cart?buy_now=1';
    } catch (err) {
      console.error('[sr-quick-buy-buy-now]', err);
      fail(btn, errorEl, 'Something went wrong. Please try again, or use Add to Cart instead.');
    }
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var quickBuyBtn = target.closest('[data-quick-buy-custom-buy-now]');
    if (quickBuyBtn) {
      event.preventDefault();
      var quickBuyFormId = quickBuyBtn.getAttribute('data-quick-buy-form-id');
      var quickBuyForm = quickBuyFormId ? document.getElementById(quickBuyFormId) : quickBuyBtn.closest('form');
      onCustomBuyNow(quickBuyBtn, quickBuyForm);
      return;
    }

    var cardBtn = target.closest('[data-product-card-custom-buy-now]');
    if (cardBtn) {
      event.preventDefault();
      onCustomBuyNow(cardBtn, cardBtn.closest('form'));
    }
  });
})();
